import { TRewardCellData } from '../atoms/reward-cell/types'

export const developers: TRewardCellData[] = [
  {
    grade: 'Junior',
    sum: '5 000 ₽',
  },
  {
    grade: 'Junior+',
    sum: '10 000 ₽',
  },
  {
    grade: 'Middle',
    sum: '30 000 ₽',
  },
  {
    grade: 'Senior',
    sum: '60 000 ₽',
  },
  {
    grade: 'Head',
    sum: '100 000 ₽',
  },
]

export const adminEmployees: TRewardCellData[] = [
  {
    grade: 'Junior',
    sum: '5 000 ₽',
  },
  {
    grade: 'Junior+',
    sum: '5 000 ₽',
  },
  {
    grade: 'Middle',
    sum: '10 000 ₽',
  },
  {
    grade: 'Senior',
    sum: '15 000 ₽',
  },
  {
    grade: 'Head',
    sum: '20 000 ₽',
  },
]
